export const getPositionCartesianMarker = ({ coordinates }) => {
  const [x, y] = coordinates.split(",").map((coordinate) => coordinate * 100);
  return {
    left: `${x}%`,
    top: `${y}%`,
  };
};
